module.exports = __webpack_public_path__ + "static/media/S1N1-4.67407c4a.svg";